var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        title: "Deneme Sürümünü Atla",
        "cancel-text": "Vazgeç",
        "ok-text": "Onayla",
        "show-footer": true,
      },
      on: { ok: _vm.confirm, cancel: _vm.close },
    },
    [
      _c("div", [
        _vm._v(
          "Deneme sürümünü atlayarak, işletmenize uygun paketi seçerek devam edebilirsiniz. Deneme sürümünü atlarsanız, bu işlem geri alınamaz."
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }